module.exports = __webpack_public_path__ + "img/gaoyuan.335b4cd2.jpg";